import React from "react";
import Col from "react-bootstrap/Col";
import SkillsBar from "./SkillsBar";

function SkillsSection({ skills, isScrolled, startIndex = 0 }) {
  return (
    <>
      {skills.map((skill, index) => (
        <SkillsBar
          key={`${skill}-${index}`}
          skill={skill.name}
          value={skill.value}
          isScrolled={isScrolled}
          index={startIndex + index}
        />
      ))}
    </>
  );
}

function SkillsTab({ skills, isScrolled }) {
  const midPoint = Math.floor(skills.length / 2);
  return (
    <>
      <Col xs={12} md={6}>
        <SkillsSection
          skills={skills.slice(0, midPoint)}
          isScrolled={isScrolled}
          startIndex={0}
        />
      </Col>
      <Col xs={12} md={6}>
        <SkillsSection
          skills={skills.slice(midPoint, skills.length)}
          isScrolled={isScrolled}
          startIndex={midPoint}
        />
      </Col>
    </>
  );
}

export default SkillsTab;
